export default __webpack_public_path__ + "static/media/html.9acc2641.svg";